query getAssignmentAndEvents($userId: String!, $language: String!, $eventLanguage: String!) {
  getAssignmentAndEvents(userId: $userId, language: $language, eventLanguage: $eventLanguage) {
    seminars {
      events {
        event {
          event {
            eventId: id {
              id
            }
          }
          eventGroup
          seminar {
            eventSeminarId: id {
              id
            }
          }
          assignment {
            eventAssignmentId: id {
              id
            }
          }
          language
          location {
            placeId {
              id {
                id
              }
            }
            roomId {
              id {
                id
              }
            }
            placeLink {
              href
              location {
                addressInformation {
                  street
                  postcode
                  city
                  country
                  region
                }
              }
            }
          }
          start {
            dateTime
            dateTimeLong
          }
          end {
            dateTime
            dateTimeLong
          }
          prices {
            price {
              price
              currency
            }
          }
          maxParticipants
          actualParticipants
          followEvents {
            followEvent {
              event {
                followEventId: id {
                  id
                }
              }
              start {
                dateTime
                dateTimeLong
              }
              end {
                dateTime
                dateTimeLong
              }
              location {
                placeId {
                  id {
                    id
                  }
                }
                roomId {
                  id {
                    id
                  }
                }
                placeLink {
                  href
                  location {
                    addressInformation {
                      street
                      postcode
                      city
                      country
                      region
                    }
                  }
                }
              }
            }
          }
        }
      }
      assignments {
        assignment {
          assignment {
            assignmentId: id {
              id
            }
          }
          title
          teaser
          state
          picture {
            href
          }
          deeplink {
            href
          }
          classifications {
            classification {
              keyId
              key
              value
            }
          }
          innings {
            inning {
              inningID {
                id {
                  inningId: id {
                    id
                  }
                }
              }
              seminars {
                id {
                  inningSeminarId: id {
                    id
                  }
                }
              }
              seminarEvents {
                id {
                  inningSeminarEventId: id {
                    id
                  }
                }
              }
              name
              startDate
              endDate
              maxParticipants
              registeredParticipants
              price
              currency
            }
          }
        }
      }
      seminars {
        seminar {
          seminar {
            seminarId: id {
              id
            }
          }
          title
          teaser
          description
          externalDescription
        }
      }
    }
    eLearnings {
      events {
        event {
          event {
            eventId: id {
              id
            }
          }
          eventGroup
          seminar {
            eventSeminarId: id {
              id
            }
          }
          assignment {
            eventAssignmentId: id {
              id
            }
          }
          location {
            placeId {
              id {
                id
              }
            }
            roomId {
              id {
                id
              }
            }
            placeLink {
              href
              location {
                addressInformation {
                  street
                  postcode
                  city
                  country
                  region
                }
              }
            }
          }
          start {
            dateTime
            dateTimeLong
          }
          end {
            dateTime
            dateTimeLong
          }
        }
      }
      assignments {
        assignment {
          assignment {
            assignmentId: id {
              id
            }
          }
          title
          teaser
          state
          picture {
            href
          }
          deeplink {
            href
          }
          classifications {
            classification {
              keyId
              key
              value
            }
          }
        }
      }
      seminars {
        seminar {
          seminar {
            seminarId: id {
              id
            }
          }
          title
          teaser
        }
      }
    }
  }
}
